import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import Loader from "./components/Loader";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import { HelmetProvider } from "react-helmet-async";
const App = lazy(() => import("./App"));

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Suspense fallback={<Loader />}>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
